var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "76 88 360 300",
    role: "img",
    "aria-label": "Cod UIT icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Cod UIT") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    textAnchor: "middle",
    fontFamily: "Montserrat, Arial, Helvetica, sans-serif",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("text", {
    x: 256,
    y: 225,
    fontSize: 118,
    fill: "#6F2C83",
    letterSpacing: -4
  }, "cod"), /*#__PURE__*/React.createElement("text", {
    x: 256,
    y: 340,
    fontSize: 108,
    fill: "#343844",
    letterSpacing: -2
  }, "UIT"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUit);
export default __webpack_public_path__ + "static/media/IconUIT.68fbe0851aeab8811d31a5d7a9601c8b.svg";
export { ForwardRef as ReactComponent };